import { Box, Title, Text, Button } from "@mantine/core";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
export default function HeroSection() {
  const navigate = useNavigate();
  const heroImages = [
    "https://images.unsplash.com/photo-1566073771259-6a8506099945",
    "https://images.unsplash.com/photo-1551882547-ff40c63fe5fa",
    "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b",
    "https://images.unsplash.com/photo-1590490360182-c33d57733427",
  ];

  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % heroImages.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Box
      style={{
        position: "relative",
        width: "100%",
        height: "85vh",
        overflow: "hidden",
      }}
    >
      {/* Background Images */}
      {heroImages.map((img, i) => (
        <Box
          key={i}
          style={{
            position: "absolute",
            inset: 0,
            backgroundImage: `url(${img}?auto=format&fit=crop&w=1600&q=80)`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            transition: "opacity 1.2s ease-in-out",
            opacity: i === index ? 1 : 0,
          }}
        />
      ))}

      {/* Dark overlay for premium feel */}
      <Box
        style={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(rgba(0,0,0,0.35), rgba(0,0,0,0.55))",
        }}
      />

      {/* Content */}
      <Box
        style={{
          position: "relative",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          padding: "0 20px",
        }}
      >
        <Title
          order={1}
          style={{
            color: "#ffffff",
            fontSize: "clamp(40px,6vw,72px)",
            fontWeight: 700,
            letterSpacing: "0.08em",
          }}
        >
          Experience Luxury 
        </Title>

        <Text
          mt="lg"
          style={{
            color: "#e8e8e8",
            fontSize: "18px",
            maxWidth: "700px",
          }}
        >
          Discover comfort, elegance, and world-class hospitality at
          Hotel Royal.
        </Text>

        <Button
          mt="xl"
          size="lg"
          radius="xl"
          onClick={() => navigate("/amenities")}
          style={{
            background: "#C9A14A",
            color: "#fff",
            paddingInline: 36,
            fontWeight: 500,
          }}
        >
          Explore 
        </Button>
      </Box>
    </Box>
  );
}